export default __webpack_public_path__ + "static/media/gallery_08.2d64f182.jpg";